import { Injectable } from "@angular/core"
import { MediaFile } from "@api/utility/models/media-library"

const GUID_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

@Injectable({
  providedIn: "root",
})
export class MediaLibraryCleanupService {
  public readonly maxDeletions = 25

  public findEntityFolder(mediaList: MediaFile[], entityId: string): MediaFile | null {
    if (!mediaList || !entityId) return null
    const matches = mediaList.filter((media) => media._mediaType === "Folder" && media.name?.endsWith(":" + entityId))
    return matches.length === 1 ? matches[0] : null
  }

  public cropIdOf(file: MediaFile): string | null {
    const fromName = file?.name?.match(GUID_PATTERN)
    if (fromName) return fromName[0].toLowerCase()

    const fromLink = file?.link?.split("/").pop()?.match(GUID_PATTERN)
    return fromLink ? fromLink[0].toLowerCase() : null
  }

  public isSweepCandidate(file: MediaFile, folderId: string): boolean {
    return file?._mediaType === "File" && file?.parentId === folderId && !!this.cropIdOf(file)
  }

  public guidsFrom(value: unknown, into: Set<string>): void {
    if (typeof value !== "string") return
    const matches = value.match(GUID_PATTERN)
    matches?.forEach((guid) => into.add(guid.toLowerCase()))
  }
}
